import { Tooltip, Typography } from 'antd';
import {
  CloseDrawerIcon,
  HomeIcon,
  LeftTailArrowIcon,
  LinkInlineIcon,
} from '@/assets/icons/icons';
import type { HelpPanelHeaderProps } from '../../types';
import styles from '../../AppHelpCenter.module.scss';
import HelpHeaderIconButton from '../HelpHeaderIconButton/HelpHeaderIconButton';

const HelpPanelHeader = ({
  title,
  canGoBack,
  showCopyLink,
  onBack,
  onHome,
  onCopyLink,
  onClose,
}: HelpPanelHeaderProps) => (
  <div className={`${styles.header} ${canGoBack ? styles.headerWithBack : ''}`}>
    <div className={styles.headerLeft}>
      {canGoBack && (
        <HelpHeaderIconButton
          icon={<LeftTailArrowIcon fill='currentColor' />}
          label='Back'
          testId='help-center-back'
          onClick={onBack}
        />
      )}
      <Typography.Text className={styles.title} ellipsis={{ tooltip: title }}>
        {title}
      </Typography.Text>
    </div>

    <div className={styles.headerRight}>
      {canGoBack && (
        <HelpHeaderIconButton
          icon={<HomeIcon color='currentColor' size={18} />}
          label='Home'
          testId='help-center-home'
          onClick={onHome}
        />
      )}
      {showCopyLink && (
        // Span gives the Tooltip a DOM node to anchor to.
        <Tooltip title='Copy link'>
          <span>
            <HelpHeaderIconButton
              icon={<LinkInlineIcon color='currentColor' />}
              label='Copy link'
              testId='help-center-copy-link'
              onClick={onCopyLink}
            />
          </span>
        </Tooltip>
      )}
      <HelpHeaderIconButton
        icon={<CloseDrawerIcon />}
        label='Close'
        testId='help-center-close'
        onClick={onClose}
      />
    </div>
  </div>
);

export default HelpPanelHeader;
